import React, { Component } from 'react';

import {
    Container,
    Row,
    Col,
    FormGroup, Label, Input,
    Button,
    Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';



import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../helpers/linkHelper';
import { API_ENDPOINT, GOOGLE_API_KEY } from '../constants';
import moment from 'moment';

/**
* List of patients for selected clinic and selected department
* @author   Aleksandar Dabic
*/

class PatientNotesPreview extends Component {
    constructor(props) {
        super(props);

        this.itemsWrapper = React.createRef();
        this.state = {
            ...props.initialData,
            items: []
        };
    }

    componentDidMount() {
        // setTimeout(() => {
        //     this.scrollToBottom();
        // }, 300);

        const { caseNumber, questionaryName } = this.getCaseInfo(this.props.items);

        this.setState({ caseNumber, questionaryName }, () => {
            if (!this.state.caseNumber || !this.state.questionaryName) {
                if (this.props.caseId) {
                    fetch(API_ENDPOINT + '/user/patients-notes/get-case-info', {
                        method: 'POST',
                        headers: {
                            'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify({ caseId: this.props.caseId })
                    }).then(res => res.json()).then((result) => {
                        let setObj = {};
                        if (result?.caseNumber) {
                            setObj.caseNumber = result.caseNumber;
                        }
                        if (result?.questionaryName) {
                            setObj.questionaryName = result.questionaryName;
                        }

                        if (Object.keys(setObj).length > 0) {
                            this.setState(setObj);
                        }
                    });
                } else if (this.props.paymentNumber) {
                    this.setState({ caseNumber: this.props.paymentNumber })
                }
            }
        });
    }

    toggle = () => {
        if (this.props.toggle) {
            this.props.toggle();
        }
    }

    formatNoteItems = (items) => {
        if (!items?.length) return [];
        let response = [];
        let numeration = 1;
        for (let i = 0; i < items.length; i++) {
            if (!items[i]) continue;
            const item = items[i];
            const note = item?.note ? item?.note?.trim() : null;
            if (!note) continue;
            const doctor = item?.doctor;
            const doctorUsername = doctor?.username ? doctor?.username : doctor?.userData?.name ? this.props.formatName(doctor?.userData?.title, doctor?.userData?.name) : 'Clinic user'.translate(this.props.lang);
            const date = item?.time?.ts ? this.props.getStringDateTs(item?.time?.ts, this.props.dateFormat) : '';
            const caseNumber = item?.caseNumber ?? 'case'.translate(this.props.lang);
            let message;
            if (item.noteType === 'paymentNotes') {
                switch (item.action) {
                    case 'unpaid-to-paid': message = `${'marked'.translate(this.props.lang)} ${caseNumber} ${'as paid on'.translate(this.props.lang)}`; break;
                    case 'paid-to-unpaid': message = `${'marked'.translate(this.props.lang)} ${caseNumber} ${'as unpaid on'.translate(this.props.lang)}`; break;
                    case 'new-note': message = `${'added a new note for'.translate(this.props.lang)} ${caseNumber} ${'on'.translate(this.props.lang)}`;
                }
            } else if (item.noteType === 'event' || item.noteType === 'referral' || (item.noteType === 'chat' && item?.caseNumber)) {
                message = `${'added a new note for'.translate(this.props.lang)} ${caseNumber} ${'on'.translate(this.props.lang)}`;
            } else if (item.noteType === 'users' || item.noteType === 'chat') {
                message = `${'added a new note for patient on'.translate(this.props.lang)}`;
            }

            let addedNote;
            if (item.action === 'new-note' || item.noteType !== 'paymentNotes') {
                addedNote = ': ' + `"${note}"`
            } else {
                addedNote = ', ' + 'with note'.translate(this.props.lang) + ': ' + `"${note}"`;
            }

            let string;
            if (doctorUsername && message && date) {
                string = doctorUsername + ' ' + message + ' ' + date;
                if (addedNote) string += addedNote;
            }
            if (!string) {
                string = 'Note'.translate(this.props.lang);
            }

            let formattedItem = `${numeration}. ${string}.`;
            response.push(formattedItem);
            numeration++;

        }

        return response;

    }
    formatNoteItems_v2 = (items) => {
        if (!items?.length) return [];
        let response = [];
        for (let i = 0; i < items.length; i++) {
            if (!items[i]) continue;
            const item = items[i];
            const note = item?.note ? item?.note?.trim() : null;
            if (!note) continue;
            const doctor = item?.doctor;
            const doctorUsername = doctor?.username ? doctor?.username : doctor?.userData?.name ? this.props.formatName(doctor?.userData?.title, doctor?.userData?.name) : 'Clinic user'.translate(this.props.lang);
            const month = item?.time?.ts ? this.props.getStringDateTs(item?.time?.ts, 'MMM')?.translate(this.props.lang) : '';
            const day = item?.time?.ts ? this.props.getStringDateTs(item?.time?.ts, 'DD') : '';
            const year = item?.time?.ts ? this.props.getStringDateTs(item?.time?.ts, 'YYYY') : '';
            const time = item?.time?.ts ? this.props.getStringDateTs(item?.time?.ts, 'HH:mm') : '';
            let dateFormat = 'DD MM YYYY';
            const formattedDate = dateFormat?.replace('YYYY', year).replace('MM', month).replace('DD', day) + ' ' + time;
            let message;
            if (item.noteType === 'paymentNotes' || item.noteType === 'payments') {
                switch (item.action) {
                    case 'unpaid-to-paid': message = `${'Marked as paid'.translate(this.props.lang)}: ${note}`; break;
                    case 'paid-to-unpaid': message = `${'Marked as unpaid'.translate(this.props.lang)}: ${note}`; break;
                    default: message = note;
                }
            } else {
                message = note;
            }

            let obj = {
                doctorUsername: doctorUsername,
                date: formattedDate,
                note: message,
                strikethrough: item?.strikethrough ?? false,

            }
            response.push(obj);

        }

        return response;

    }
    scrollToBottom = () => {
        const wrapper = this.itemsWrapper?.current;
        if (wrapper) {
            wrapper.scrollTop = wrapper?.scrollHeight;
        }
    };
    addNewNote = () => {
        const caseId = this.props.caseId;
        const newNote = this.state.newNote;

        let data = {
            caseId: caseId,
            note: newNote,
            clinicId: this.props.selectedClinic,
            groupId: this.props.selectedGroup,
            conversationId: this.props.conversationId,
        }

        fetch(API_ENDPOINT + '/user/patients-notes/add-new', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(res => res.json()).then((result) => {
            if (result?.success) {
                this.setState({ newNote: '' }, () => {
                    if (this.props.refreshItems) this.props.refreshItems();
                    if (this.props.toggle) this.props.toggle();
                })
            }
        })
    }
    getCaseInfo = (items) => {
        let caseNumber;
        let questionaryName
        if (!items?.length) return { caseNumber, questionaryName };
        for (let i = 0; i < items.length; i++) {
            if (!items[i]) continue;
            const item = items[i];
            if (item?.caseNumber && !caseNumber) {
                caseNumber = item.caseNumber;
            }
            if (item?.questionaryName && !questionaryName) {
                questionaryName = item.questionaryName;
            }
            if (caseNumber && questionaryName) break;
        }
        return { caseNumber, questionaryName };
    }

    render() {
        const { isOpen, showInModal, addNoteEnabled, caseId } = this.props;
        const items = this.formatNoteItems_v2(this.props.items);
        const { caseNumber, questionaryName } = this.state;

        const infoText = 'Maximum of 3 active notes at a time: one from the Calendar, one from Payments, and one from the Patient Profile/Case List. A new note replaces the previous one from the same section.'.translate(this.props.lang);
        const notesContent = <>
            <div className="patient-notes-items-wrap-v2" ref={this.itemsWrapper}>
                <div className="patient-notes-header">
                    <div className="patient-notes-header-info">
                        {infoText}
                    </div>
                    <div className="patient-notes-header-title">
                        {questionaryName}
                    </div>
                    {
                        caseNumber ?
                            <div className="patient-notes-header-title">
                                <span>{'CaseID'.translate(this.props.lang)}:</span> {caseNumber}
                            </div>
                            :
                            null
                    }

                </div>
                <div className='patient-notes-items-list-v2'>
                    {
                        items?.length ?
                            items?.map((item, index) => {
                                return (
                                    <div key={index} className="patient-note-item-v2">
                                        <div className='patient-note-item-info'>
                                            <div>{item?.date}</div>
                                            <div>{item?.doctorUsername}</div>
                                        </div>
                                        <div className='patient-note-item-text' style={item?.strikethrough ? { textDecoration: 'line-through' } : {}}>
                                            {item?.note}
                                        </div>
                                    </div>
                                )
                            })
                            :
                            <div className="patient-no-note-item">
                                {'There are still no notes added.'.translate(this.props.lang)}
                            </div>
                    }
                </div>


            </div>
            {
                addNoteEnabled && caseId && showInModal ?
                    <div className="add-patient-note-item-wrap">
                        <Input
                            type="textarea"
                            placeholder={'Enter new note'.translate(this.props.lang)}
                            style={{ height: 100 }}
                            value={this.state.newNote}
                            onChange={(e) => {
                                this.setState({ newNote: e.target.value })
                            }}
                        />

                    </div>
                    : null
            }
        </>;
        return (
            showInModal ?
                <Modal
                    isOpen={isOpen}
                    centered
                    size={'lg'}
                >
                    <ModalHeader
                        toggle={() => this.toggle()}
                        close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.toggle()}>&times;</button>}
                        style={{ paddingBottom: 0 }}
                    >
                        {'Notes'.translate(this.props.lang)}
                    </ModalHeader>
                    <ModalBody>
                        {notesContent}
                    </ModalBody>
                    <ModalFooter style={{ display: 'flex', justifyContent: 'center' }} className='buttons-right-blue'>
                        {
                            addNoteEnabled && caseId ?
                                <Button
                                    disabled={!this.state.newNote || this.state.newNote === '' || this.state.newNote.trim() === ''}
                                    color="primary"
                                    style={{ margin: 10 }}
                                    onClick={() => {
                                        this.addNewNote();
                                    }}
                                >
                                    {'Save'.translate(this.props.lang)}
                                </Button>
                                : null
                        }
                        <Button type="submit" color="primary" onClick={() => this.toggle()} >{'Close'.translate(this.props.lang)}</Button>

                    </ModalFooter>
                </Modal>
                :
                notesContent
        );


    }
}
export default PatientNotesPreview;